
import axios from 'axios';
import config from '../../config';
import { getAxiosConfigUserToken } from '../../util/utilFunction';


  
export const postSendSMS = (smsObject)=>{
   const url = `${config.apiUrl}/v1/util/sendSMS`;
   return axios.post(url,smsObject,getAxiosConfigUserToken())
   .then(response => response.data);
} 

export const postNotificationSend = async (notificationObj)=>{
   const url = `${config.apiUrl}/v1/util/notificationSend`;
   return await axios.post(url,notificationObj,getAxiosConfigUserToken())
   .then(response => response.data);
}

export const getBanksApi = async()=>{
   const url = `${config.apiUrl}/v1/util/banks`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
}
 
export const getInterestApi = async()=>{
    const url = `${config.apiUrl}/v1/util/interests`;
    return await axios.get(url,getAxiosConfigUserToken())
    .then(response => response.data)
 }
 export const getDepartmentsApi = async()=>{
    const url = `${config.apiUrl}/v1/util/departments`;
    return await axios.get(url,getAxiosConfigUserToken())
    .then(response => response.data)
 }
 export const getLanguagesApi = async()=>{
    const url = `${config.apiUrl}/v1/util/languages`;
    return await axios.get(url,getAxiosConfigUserToken())
    .then(response => response.data)
 }
 export const getSettingsApi = async(projectId)=>{
   const url = `${config.apiUrl}/v1/util/settings/${projectId}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
}

export const getSettingsAllApi = async(projectId)=>{
   const url = `${config.apiUrl}/v1/util/settings/`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
}

export const putUpdateSettingsByProjectId = async(settingsObj)=>{
   const url = `${config.apiUrl}/v1/util/settings/`;
   return axios.put(url,settingsObj,getAxiosConfigUserToken())
   .then(response => response.data);
}

export const getSettingsMemurMaasKatsayiApi = async()=>{
   const url = `${config.apiUrl}/v1/util/settings/memurMaasKatsayi/`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
}
export const postSaveOrUpdateSettingsApi = async(settings)=>{
   const url = `${config.apiUrl}/v1/util/settings/`;
   return await axios.post(url,settings,getAxiosConfigUserToken())
   .then(response => response.data)
}
export const putUpdateSettingsApi = async(settings)=>{
   const url = `${config.apiUrl}/v1/util/settings/`;
   return await axios.put(url,settings,getAxiosConfigUserToken())
   .then(response => response.data)
}

 export const postUploadItemFileApi = async(formData,projectId,onUploadProgress)=>{
              try{
              const url = `${config.apiUrl}/v1/${projectId}/upload/itemFile/`; 
              return await axios.post(url,formData,{
                      
                          headers:{
                              'Content-Type':'multipart/form-data',
                              ...getAxiosConfigUserToken().headers,
                          },
                          
                          onUploadProgress
                  }).then(response => response.data) 
  
              } catch (err) {
                  if(err.response.status ===500){
                      return {status:false , errorMessage:"Sunucu problemi var" }
                  }
                  else{
                      console.log(err.response.data.msg);
                      return {status:false , errorMessage:err.response.data.msg }
                  }
              }
  }
  export const deleteItemFileApi = (file,projectId)=>{
    const url = `${config.apiUrl}/v1/${projectId}/upload/deleteItemFile`;
    return axios.post(url,file,getAxiosConfigUserToken())
    .then(response => response.data);
 }

 export const putUpdateItemFileList = async(fileAtttachementObject)=>{
   const url = `${config.apiUrl}/v1/itemFile/itemFileList`;
   return  await axios.put(url,fileAtttachementObject,getAxiosConfigUserToken())
   .then(response => response.data);
}
export const putUpdateItemFile = async(fileAtttachementObject)=>{
   const url = `${config.apiUrl}/v1/itemFile/`;
   return  await axios.put(url,fileAtttachementObject,getAxiosConfigUserToken())
   .then(response => response.data);
}

 export const postSaveItemFileList = (fileAtttachementObject)=>{
    const url = `${config.apiUrl}/v1/itemFile/itemFileList`;
    return axios.post(url,fileAtttachementObject,getAxiosConfigUserToken())
    .then(response => response.data);
 }

 export const getItemFileByItemApi = async(itemId)=>{
    const url = `${config.apiUrl}/v1/itemFile/byItemId/${itemId}`;
    return await axios.get(url,getAxiosConfigUserToken())
    .then(response => response.data)
 }

 export const deleteItemFileByItemApi = async(itemId)=>{
   const url = `${config.apiUrl}/v1/itemFile/byItemId/${itemId}`;
   return await axios.delete(url,getAxiosConfigUserToken())
   .then(response => response.data)
}

 export const getAssigmentEditorItemListPDFByProjectIdApi = (ProjectId,lang)=>{
    const url = `${config.apiUrl}/v1/pdf/itemAssigned/assigmentEditorItemListByProjectId/${ProjectId}?lang=${lang}`;
    return axios.get(url,{
       method: 'GET',
       responseType: 'blob',
       ...getAxiosConfigUserToken()
    })
    .then(response => {
       const file = new Blob(
          [response.data], 
          {type: 'application/pdf'});
          return file;
    });
 }
 export const getAssigmentEditorItemListPDFByEditorIdApi = (editorId,ProjectId,lang)=>{
    const url = `${config.apiUrl}/v1/pdf/itemAssigned/assigmentEditorItemListByEditorId/${editorId}/${ProjectId}?lang=${lang}`;
    return axios.get(url,{
       method: 'GET',
       responseType: 'blob',
       ...getAxiosConfigUserToken()
    })
    .then(response => {
       const file = new Blob( 
          [response.data], 
          {type: 'application/pdf'});
          return file;
    });
 }
 export const getAssigmentEditorItemListFullPDFByProjectIdApi = (ProjectId,lang)=>{
    const url = `${config.apiUrl}/v1/pdf/itemAssigned/assigmentEditorItemListFullByProjectId/${ProjectId}?lang=${lang}`;
    return axios.get(url,{
       method: 'GET',
       responseType: 'blob',
       ...getAxiosConfigUserToken()
    })
    .then(response => {
       const file = new Blob(
          [response.data], 
          {type: 'application/pdf'});
          return file;
    });
 }

 
export const getDocumentByIdApi = (fileId)=>{
   const url = `${config.apiUrl}/v1/util/document/${fileId}`;
   return axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data);
 }

 
 export const getItemFileByIdApi = (fileId)=>{
   const url = `${config.apiUrl}/v1/itemFile/${fileId}`;
   return axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data);
 }


export const postUploadItemReviewFileApi = async(formData,projectId)=>{
             try{
             const url = `${config.apiUrl}/v1/${projectId}/upload/itemReviewFile/`;
             return await axios.post(url,formData,{
                         headers:{
                             'Content-Type':'multipart/form-data',
                             ...getAxiosConfigUserToken().headers
                         }
                 }).then(response => response.data)
 
             } catch (err) {
                 if(err.response.status ===500){
                     
                     return {status:false , errorMessage:"Sunucu problemi var" }
                 }
                 else{
                     console.log(err.response.data.msg);
                     return {status:false , errorMessage:err.response.data.msg }
                 }
             }
 }

 export const deleteItemReviewItemFileApi = (itemFile)=>{
   const url = `${config.apiUrl}/v1/upload/deleteItemReviewItemFile`;
   return axios.post(url,itemFile)
   .then(response => response.data);
}

export const getItemByUidApi = async(uid)=>{
   const url = `${config.apiUrl}/v1/util/item/byUid/${uid}`;
   return await axios.get(url)
   .then(response => response.data)
}



//////taslak harcama pusulasi
export const getExpenseSlipTemplateFileByItemIdAndUserIdApi = (itemId,userId)=>{
   const url = `${config.apiUrl}/v1/word/harcamaPusulasi/${itemId}/${userId}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob',
      ...getAxiosConfigUserToken()
   })
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/octet-stream'});
         return file;
   });
}

/////taslak sozlesme formu
export const getSozlesmeByItemIdApi = (itemId)=>{
   const url = `${config.apiUrl}/v1/word/sozlesme/${itemId}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob',
      ...getAxiosConfigUserToken()
   })
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/octet-stream'});
         return file;
   });
}
/////telif Devir sozlesme formu
export const getTelifDevirSozlemesiByItemIdApi = (itemId)=>{
   const url = `${config.apiUrl}/v1/word/telifDevirSozlesmesi/${itemId}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob',
      ...getAxiosConfigUserToken()
   })
   .then(response => {
      const file = new Blob(
         [response.data],  
         {type: 'application/octet-stream'});
         return file;
   });
}




//email ile yazara ve inceleyiciye sözleşme formu veya harcama pusulası göndermek için.
export const postSendEmailFileWriterAndReferee = (data)=>{
   const url = `${config.apiUrl}/v1/util/sendEmailFileWriterAndReferee/`;
   return axios.post(url,data,getAxiosConfigUserToken())
   .then(response => response.data);
}

export const getHesapVeIncelemeFormuPDFByItemApi = (itemId , signName , signTitle)=>{
   const url = `${config.apiUrl}/v1/pdf/hesapVeIncelemeFormu/${itemId}?signName=${signName}&signTitle=${signTitle}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob',
      ...getAxiosConfigUserToken()
   })
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/pdf'});
         return file;
   });
}
export const getFullFileZipForAdvisoryBoardByItemApi = (itemId )=>{
   const url = `${config.apiUrl}/v1/pdf/fullFileZipForAdvisoryBoard/${itemId}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob',
      ...getAxiosConfigUserToken()
   })
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/zip'});
         return file;
   });
}


/////////////////////////eski




export const getUserStatisticsByUserIdApi = async(userId)=>{
    const token = localStorage.getItem("userTokenTSYS");
    const configAxios = { 
       headers: { Authorization: "Bearer " + token }
    }

    const url = `${config.apiUrl}/v1/util/statistics/user/${userId}`;
    return await axios.get(url,configAxios)
    .then(response => response.data)
 }

export const getQuestionByTypeApi = async(type)=>{
    const url = `${config.apiUrl}/v1/question/type/${type}`;
    return await axios.get(url)
    .then(response => response.data)
 }

export const getEdsisDataByEdsisIdApi = async(edsisId)=>{
    const url = `${config.apiUrl}/v1/util/getDataEdsis/${edsisId}`;
    return await axios.get(url)
    .then(response => response.data)
 }
 export const postUploadSubmissionFileApi = async(formData)=>{
              try{
              const url = `${config.apiUrl}/v1/upload/submissionFile/`;
              return await axios.post(url,formData,{
                          headers:{
                              'Content-Type':'multipart/form-data'
                          }
                  }).then(response => response.data)
  
              } catch (err) {
                  if(err.response.status ===500){
                      return {status:false , errorMessage:"Sunucu problemi var" }
                  }
                  else{
                      console.log(err.response.data.msg);
                      return {status:false , errorMessage:err.response.data.msg }
                  }
              }
  }

  export const deleteSubmissionReviewItemFileApi = (itemFile)=>{
    const url = `${config.apiUrl}/v1/upload/deleteSubmissionReviewItemFile`;
    return axios.post(url,itemFile)
    .then(response => response.data);
 }

 export const postUploadActivityAttachment = async(formData,userId)=>{
              try{
              const url = `${config.apiUrl}/v1/upload/activityAttachment/${userId}`;
              return await axios.post(url,formData,{
                          headers:{
                              'Content-Type':'multipart/form-data'
                          }
                  }).then(response => response.data)
  
              } catch (err) {
                  if(err.response.status ===500){
                      return {status:false , errorMessage:"Sunucu problemi var" }
                  }
                  else{
                      console.log(err.response.data.msg);
                      return {status:false , errorMessage:err.response.data.msg }
                  }
              }
  }

  export const getActivityDataByActivityIdApi = async(activityId)=>{
    const url = `${config.apiUrl}/v1/activityAttachment/byActivityId/${activityId}`;
    return await axios.get(url)
    .then(response => response.data)
 }


 
 export const deleteActivityAttachmentApi = (activityAttachment)=>{
    const url = `${config.apiUrl}/v1/upload/deleteActivityAttachment`;
    return axios.post(url,activityAttachment)
    .then(response => response.data);
 }

 
  export const postReminderMessage = (reminderObject)=>{
   const url = `${config.apiUrl}/v1/util/reminderMessage`;
   return axios.post(url,reminderObject)
   .then(response => response.data);
}

export const getJournallNameAllApi = async()=>{
   const url = `${config.apiUrl}/v1/util/journalName`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data) 
}
export const putUpdateJournallNameApi = async(obj)=>{
   const url = `${config.apiUrl}/v1/util/journalName`;
   return await axios.put(url,obj,getAxiosConfigUserToken())
   .then(response => response.data) 
}


/////telif Devir sozlesme formu
export const getMaliHakDevirSozlemesiByItemIdApi = (itemId,userId)=>{
   const url = `${config.apiUrl}/v1/word/mhkSozlesme/${itemId}/${userId}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob',
      ...getAxiosConfigUserToken()
   })
   .then(response => {
      const file = new Blob(
         [response.data],  
         {type: 'application/octet-stream'});
         return file;
   });
}
/////telif Devir sozlesme formu
export const getTemliknameByItemIdApi = (itemId,userId)=>{
   const url = `${config.apiUrl}/v1/word/temlikname/${itemId}/${userId}`;
   return axios.get(url,{
      method: 'GET',
      responseType: 'blob',
      ...getAxiosConfigUserToken()
   })
   .then(response => {
      const file = new Blob(
         [response.data],  
         {type: 'application/octet-stream'});
         return file;
   });
}

export const sendPushExpoNotificationApi = async(itemId)=>{
   const url = `${config.apiUrl}/v1/util/sendPushExpoNotification/${itemId}`;
   return await axios.get(url,getAxiosConfigUserToken())
   .then(response => response.data)
}

export const putUpdateItemReSendSmilarityReportApi = async (itemId)=>{
   const url = `${config.apiUrl}/v1/util/reSendSmilarityReport/${itemId}`;
   return await axios.put(url,{},getAxiosConfigUserToken())
   .then(response => response.data);
} 

